import styled from 'styled-components';
import producerBackground from '../../../assets/images/producer-background.png';

export const HeroContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
  background-image: url(${producerBackground});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  @media (max-width: 768px) {
    min-height: 100vh;
    background-position: center right;
  }
`;

export const LeftContainer = styled.div`
  width: 70%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.62), rgba(207, 131, 32, 0.09));
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  
  @media (max-width: 768px) {
    width: 100%;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5));
    padding: 20px 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 745px;
  text-align: left;
  padding: 0 3rem;
  position: relative;
  z-index: 2;
  
  @media (max-width: 768px) {
    padding: 0 2rem;
    max-width: 100%;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    padding: 0 1.5rem;
  }
`;

export const Title = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 1.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  line-height: 1.2;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
    margin-bottom: 1rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.8rem;
    line-height: 1.3;
  }
`;

export const Description = styled.p`
  font-size: 1.2rem;
  font-weight: 300;
  color: #fff;
  margin-bottom: 2.5rem;
  line-height: 1.6;
  white-space: normal;
  word-break: keep-all;
  max-width: 600px;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 2rem;
    line-height: 1.5;
  }
  
  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }
`;

export const CTAButton = styled.button`
  background: linear-gradient(90deg, rgb(255, 122, 0) 0%, rgb(255, 77, 0) 100%);
  color: #fff;
  border: none;
  border-radius: 60px;
  padding: 1.25rem 3rem;
  font-size: 1.25rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 6px 15px rgba(255, 122, 0, 0.35);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(255, 122, 0, 0.45);
  }
  
  @media (max-width: 1024px) {
    padding: 1rem 2.5rem;
    font-size: 1.15rem;
    max-width: 360px;
  }

  @media (max-width: 768px) {
    padding: 1rem 2.5rem;
    font-size: 1.12rem;
    width: 100%;
    max-width: 360px;
  }
  
  @media (max-width: 480px) {
    padding: 0.9rem 2rem;
    font-size: 1rem;
  }
`;

export const RightContainer = styled.div`
  width: 50%;
  
  @media (max-width: 768px) {
    display: none;
  }
`;